import { Button, tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import React from "react";
import { Label } from "../../../components/Typography";
import { AccountSettingsCard } from "./AccountSettingsCard";
import { DAILY_ORDER_LIMIT_TOOLTIP, EMPTY_FIELD_PLACEHOLDER, QUEUED_ORDER_LIMIT_TOOLTIP } from "./accountSettingsCopy";
import { FieldRow } from "./FieldRow";
import { LabeledField } from "./LabeledField";

function formatLimit(value?: number): string {
  return typeof value === "number" ? value.toLocaleString() : EMPTY_FIELD_PLACEHOLDER;
}

interface OrderCardProps {
  maxOrders?: number;
  limitQueueSize?: number;
  showTaxExemption: boolean;
  onUploadTaxExempt: () => void;
}

export const OrderCard: React.FC<OrderCardProps> = ({
  maxOrders,
  limitQueueSize,
  showTaxExemption,
  onUploadTaxExempt,
}) => {
  return (
    <AccountSettingsCard title="Order" data-testid="order-card">
      <FieldRow>
        <LabeledField
          label="Daily Order Limit"
          value={formatLimit(maxOrders)}
          tooltip={DAILY_ORDER_LIMIT_TOOLTIP}
          testId="order-daily-limit"
        />
        <LabeledField
          label="Queued Order Limit"
          value={formatLimit(limitQueueSize)}
          tooltip={QUEUED_ORDER_LIMIT_TOOLTIP}
          testId="order-queued-limit"
        />
      </FieldRow>

      {showTaxExemption && (
        <Flex.Column gap={8} data-testid="order-tax-exemption">
          <Flex.Row sx={{ color: tokens.color.semantic.text.subtle }}>
            <Label>Tax Exemption</Label>
          </Flex.Row>
          <Flex.Row>
            <Button variant="outlined" intent="primary" size="small" onClick={onUploadTaxExempt}>
              Upload Tax-Exempt Document
            </Button>
          </Flex.Row>
        </Flex.Column>
      )}
    </AccountSettingsCard>
  );
};
